import { Link } from 'react-router-dom'
import { PawPrint, Calendar, Users } from 'lucide-react'

const features = [
  {
    icon: <PawPrint size={28} strokeWidth={1.5} />,
    title: 'Patient Records',
    text: 'Comprehensive medical histories, vaccination records, and treatment plans — all in one place for every patient.',
  },
  {
    icon: <Calendar size={28} strokeWidth={1.5} />,
    title: 'Appointment Scheduling',
    text: 'Manage bookings, reminders, and check-ins with a clear schedule view for your entire practice.',
  },
  {
    icon: <Users size={28} strokeWidth={1.5} />,
    title: 'Team Collaboration',
    text: 'Role-based access for vets, technicians, and reception staff so everyone sees exactly what they need.',
  },
]

export default function Landing() {
  return (
    <div className="text-text">
      {/* Nav */}
      <nav className="flex justify-between items-center px-10 py-4 bg-surface border-b border-border">
        <span className="font-bold text-[1.25rem] text-accent no-underline">Vet VPMS</span>
        <div>
          <Link
            to="/login"
            className="px-5 py-2 bg-transparent text-accent rounded no-underline text-[0.95rem] font-semibold border border-accent mr-2 hover:bg-accent-muted transition-colors"
          >
            Sign In
          </Link>
          <Link
            to="/register"
            className="px-5 py-2 bg-accent text-accent-contrast rounded no-underline text-[0.95rem] font-semibold hover:bg-accent-hover transition-colors"
          >
            Create Account
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <section
        className="text-white text-center px-10 py-[5rem]"
        style={{ background: 'linear-gradient(135deg, #2f7d6c 0%, #1a4c41 100%)' }}
      >
        <p className="text-[0.85rem] font-semibold tracking-[0.1em] uppercase opacity-75 mb-4">
          Veterinary Practice Management
        </p>
        <h1 className="text-[clamp(2rem,5vw,3.25rem)] font-bold leading-[1.15] mx-auto mb-5 max-w-[700px]">
          Modern care management for veterinary teams
        </h1>
        <p className="text-[1.125rem] opacity-85 max-w-[520px] mx-auto mb-10 leading-[1.6]">
          Streamline patient records, scheduling, and team workflows — so you can
          focus on what matters most.
        </p>
        <Link
          to="/register"
          className="inline-block px-9 py-[0.85rem] bg-white text-[#2f7d6c] rounded-lg no-underline font-bold text-base shadow-[0_4px_16px_rgba(0,0,0,0.15)] mr-4 hover:opacity-90 transition-opacity"
        >
          Create Account
        </Link>
        <Link
          to="/login"
          className="inline-block px-9 py-[0.85rem] bg-transparent text-white rounded-lg no-underline font-bold text-base border-2 border-white/70 hover:bg-white/10 transition-colors"
        >
          Sign In
        </Link>
      </section>

      {/* Features */}
      <section className="grid [grid-template-columns:repeat(auto-fit,minmax(260px,1fr))] gap-6 px-10 py-16 max-w-[1100px] mx-auto">
        {features.map((f) => (
          <div
            key={f.title}
            className="bg-surface border border-border rounded-xl p-8 shadow-[0_2px_8px_rgba(0,0,0,0.05)]"
          >
            <div className="mb-4 text-accent">{f.icon}</div>
            <h3 className="font-semibold text-[1.1rem] mb-2 text-accent">{f.title}</h3>
            <p className="text-[0.95rem] text-text-2 leading-[1.6]">{f.text}</p>
          </div>
        ))}
      </section>

      {/* Footer */}
      <footer className="text-center px-8 py-8 text-sm text-text-3 border-t border-border">
        © {new Date().getFullYear()} Vet VPMS. All rights reserved.
      </footer>
    </div>
  )
}
